const thanks2 = (data) => {
  const color = data.color;

  return {
    id: "test-slide-3",
    elements: [
      {
        type: "shape",
        id: "vSheCJ",
        left: 183.5185185185185,
        top: 175.5092592592593,
        width: 605.1851851851851,
        height: 185.18518518518516,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}c7`,
        fixedRatio: false,
        rotate: 0,
      },
      {
        type: "shape",
        id: "Mpwv7x",
        left: 211.29629629629628,
        top: 201.80555555555557,
        width: 605.1851851851851,
        height: 185.18518518518516,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}99`,
        fixedRatio: false,
        rotate: 0,
        opacity: 0.7,
      },
      {
        type: "text",
        id: "WQOTAp",
        left: 304.9074074074074,
        top: 198.10185185185182,
        width: 417.9629629629629,
        height: 140,
        content:
          "<p style='text-align: center;'><strong><span style='color: #ffffff;'><span style='font-size: 80px'>感谢观看</span></span></strong></p>",
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        wordSpace: 5,
      },
      {
        type: "shape",
        id: "nzC_M8vnxq",
        width: 1000,
        height: 181.77753280839895,
        left: 0.2793700787401434,
        top: 471.61123359580057,
        viewBox: [200, 200],
        path: "M 0 20 C 60 60 140 -40 200 20 L 200 180 C 140 140 60 240 0 180 L 0 20 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
    ],
    background: {
      type: "solid",
      color: `#fff`,
    },
  };
};

export default thanks2;
